export default {
  path: '/service',
  name: 'service',
  redirect: '/service/cleaning',
  component: () => import('../views/service/index.vue'),
  meta: {
    headerTitle: '房务',
    icon: 'ab-iconfont ab-icon-service',
    showBadge: true,
    auth: 1012
  },
  children: [
    {
      path: 'cleaning',
      name: 'cleaning',
      redirect: '/service/cleaning/roomList',
      component: () => import('../views/service/cleaning/index.vue'),
      meta: {
        headerTitle: '保洁管理',
        icon: 'service-clean'
      },
      children: [
        {
          path: 'roomList',
          name: 'roomList',
          component: () => import('../views/service/cleaning/roomList.vue'),
          meta: {
            headerTitle: '每日任务'
          }
        },
        {
          path: 'statistic',
          name: 'statistic',
          component: () => import('../views/service/cleaning/statistic.vue'),
          meta: {
            headerTitle: '任务统计'
          }
        },
        {
          path: 'cleaner',
          name: 'cleaner',
          redirect: '/service/cleaning/cleaner/list',
          component: () => import('../views/service/cleaning/cleaner/index.vue'),
          meta: {
            headerTitle: '保洁员'
          },
          children: [
            {
              path: 'list',
              component: () => import('../views/service/cleaning/cleaner/list.vue'),
              name: 'list',
              meta: {
                headerTitle: '保洁员'
              }
            },
            {
              path: 'add',
              name: 'add',
              component: () => import('../views/service/cleaning/cleaner/add.vue'),
              meta: {
                headerTitle: '添加保洁员',
                hasBreadcrumb: true,
                isDetailPage: true
              }
            }
          ]
        },
        {
          path: 'setting',
          name: 'setting',
          component: () => import('../views/service/cleaning/setting.vue'),
          meta: {
            headerTitle: '价格设置'
          }
        }
      ]
    }
  ]
}
